import styled from 'styled-components';

import { LinkStyles } from '../../ui';

export const WrapperFeatures = styled.div``;

export const DocLink = styled(LinkStyles)`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 14px;
`;

export const DocLinkLabel = styled.div`
  font-weight: 700;
  margin-right: 10px;
`;
